



















import Vue from "vue";
import userManager from "@/services/userManager";
import ganiAsiaTenantCodes from "@/constants/ganiAsiaTenantCodes";

export default Vue.extend({
  data() {
    return {
      self: this,
      item: null,
      currentTab: "",
      permitted: false,
      tabs: {
        dummy: {
          label: "Tổng thống kê quốc gia",
        },
        product_groups: {
          label: "Nhóm sản phẩm",
          condition() {
            return userManager.checkRole(["kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        index: {
          label: "Tổng quan",
          condition() {
            return userManager.checkRole(["kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        telesales: {
          label: "Telesales",
          condition() {
            return userManager.checkRole(["kt", "vdl", "vd"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        in_transit_products: {
          label: "Hàng đi đường",
          condition() {
            return (userManager.checkRole(["kt"]) || (userManager.checkRole(["qlk"]) && userManager.checkRole(["vdl"]))) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        in_warehouse_products: {
          label: "Hàng tồn kho",
          condition() {
            return userManager.checkRole(["kt", "qlk"]) || ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
        purchase_commands: {
          label: "Mua hàng",
          condition() {
            return userManager.checkRole(["kt"]) && !ganiAsiaTenantCodes.includes(userManager.tenantCode());
          },
        },
      },
    };
  },
  async created() {
    this.checkPermitted();
  },
  methods: {
    checkPermitted() {
      this.permitted = userManager.checkRole(["kt", "vd", "vdl", "qlk"]) || ganiAsiaTenantCodes.includes(userManager.tenantCode());
    },
  },
});
